export default "__VITE_ASSET__B_KzCZOI__"